import { useState, useEffect } from 'react'
import api from '../lib/api'

const MESES = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
]

const now = new Date()
const PERIODO_OPTIONS = Array.from({ length: 6 }, (_, i) => {
  const d = new Date(now.getFullYear(), now.getMonth() - i, 1)
  return { value: `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`, label: `${MESES[d.getMonth()]} ${d.getFullYear()}` }
})

function ReporteCard({ title, endpoint, tenants }) {
  const [tenantId, setTenantId] = useState('')
  const [periodo,  setPeriodo]  = useState(PERIODO_OPTIONS[0].value)

  const download = (ext) => {
    if (!tenantId) return alert('Selecciona un tenant primero.')
    const url = `${import.meta.env.VITE_ADMIN_API_URL ?? '/api/admin'}/reportes/${endpoint}?tenant_id=${tenantId}&periodo=${periodo}&format=${ext}`
    window.open(url, '_blank')
  }

  return (
    <div className="panel">
      <div className="panel-head">{title}</div>
      <div className="panel-body" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div className="form-group">
          <label className="form-label">Tenant / Empresa</label>
          <select className="form-input" value={tenantId} onChange={e => setTenantId(e.target.value)}>
            <option value="">— Selecciona —</option>
            {tenants.map(t => (
              <option key={t.id} value={t.id}>{t.company_name} ({t.db_database})</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Período</label>
          <select className="form-input" value={periodo} onChange={e => setPeriodo(e.target.value)}>
            {PERIODO_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button className="btn btn-primary" onClick={() => download('pdf')}>↓ PDF</button>
          <button className="btn btn-secondary" onClick={() => download('zip')}>↓ ZIP</button>
        </div>
      </div>
    </div>
  )
}

export default function Reportes() {
  const [tenants, setTenants] = useState([])

  useEffect(() => {
    api.get('/tenants?per_page=100').then(({ data }) => setTenants(data.data ?? []))
  }, [])

  return (
    <>
      <div className="topbar">
        <div className="breadcrumb"><strong>Reportes MH</strong> — Generación por tenant</div>
      </div>
      <div className="content">
        <div className="warn-banner">
          ⚠ Los reportes consultan la BD individual de cada tenant. Selecciona la empresa antes de generar.
        </div>
        <div className="two-col">
          <ReporteCard title="Libro de Ventas"                    endpoint="libro-ventas"           tenants={tenants} />
          <ReporteCard title="Libro Crédito Fiscal"               endpoint="libro-credito-fiscal"   tenants={tenants} />
          <ReporteCard title="Anexo Consumidor Final — MH"        endpoint="anexo-consumidor-final" tenants={tenants} />
          <ReporteCard title="Anexo Documentos Anulados — MH"     endpoint="anexo-documentos-anulados" tenants={tenants} />
        </div>
      </div>
    </>
  )
}
